import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import cs from "classnames";
import { ReactComponent as CloseIcon } from "../../../assets/cross.svg";
import "./styles.scss";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 0,
  p: 2,
  width: "100%",
  borderRadius: 1,
};

interface CustomModalProps {
  open?: boolean;
  handleClose?: (any) => void;
  background?: string;
  secondary?: boolean;
  fillCloseIcon?: string;
  closeIcon?: boolean;
  width?: any;
  fixedCloseIcon?: boolean;
  moreStyle?: any;
}

const CustomModal: React.FC<CustomModalProps> = ({
  open = true,
  handleClose = () => null,
  background,
  secondary = false,
  fillCloseIcon = "#000`",
  closeIcon = true,
  width = 400,
  children,
  fixedCloseIcon,
  moreStyle = {},
}) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            ...style,
            maxWidth: width,
            width: "90%",
            background: background
              ? background
              : secondary
              ? "#41c175"
              : "#fff",
            ...moreStyle,
          }}
        >
          {closeIcon && (
            <div
              className={cs("d-flex justify-content-end", {
                ["fixedCloseIcon"]: fixedCloseIcon,
              })}
            >
              <CloseIcon
                className={cs("closeIcon")}
                style={{ fill: secondary ? "#fff" : fillCloseIcon }}
                onClick={handleClose}
              />
            </div>
          )}

          {children}
        </Box>
      </Fade>
    </Modal>
  );
};
export default CustomModal;
